/*
 * @Author: sam.hongyang
 * @LastEditors: sam.hongyang
 * @Description: drag and sort 指令
 * @Date: 2019-05-15 11:26:13
 * @LastEditTime: 2019-05-17 09:59:39
 */
import Sortable from 'sortablejs'

/* TODO: 指令设置相关参数和回调函数 */
/***
 * @param group 用于确定组元素
 * @default `taurus`
 * 1. group: 'taurus'
 * 2. group: { name: 'taurus', pull: 'clone'/true/false, put: 'clone'/true/false }
 * 3. 默认情况下， 只要group相同，就可以实现`pull`和`put`
 *
 * @param animation 动画响应时间
 * @default `300`
 *
 * @param store 用于保存排序，默认情况下不开启
 *
 * @param handle 用于设置拖拽区域,默认不设置，所有区域可拖拽
 * @default `''` 值为class选择器
 *
 * @param filter 用于设置不能拖拽的元素
 * @default `.drag__ignore` 值为class选择器
 *
 * @param draggable 用于设置拖拽的元素
 * @default `.drag__item` 值为class选择器, 指令会默认添加这个class
 *
 * @param ghostClass 用于选择已选中的元素，并设置其class
 * @default `drag__selected` 值为class选择器, 指令会在操作过程汇总添加这个class
 *
 * @param chosenClass 推拽选中的元素class
 * @default `drag__chosen`
 *
 * @param dragClass 拖拽对象的class
 * @default `drag__sortable`
 */

export default {
  name: 'TDrag',
  inserted (el, binding, node) {
    if (!Sortable) {
      throw new Error('[draggable]: cannot locate Sortable.js.')
    }
    const children = el.children
    if (!children || !children.length) {
      throw new Error('[taurus]: drag directive, el children not exist')
    }
    let value = binding.value
    let originalData = value && value.originalData ? value.originalData : []

    const {
      group = '',
      animation = 250,
      store = null,
      handle = '',
      filter = '.drag__ignore',
      draggable = '.drag__item',
      ghostClass = 'drag__selected',
      chosenClass = 'drag__chosen',
      dragClass = 'drag__sortable',
      sort = true,
      disabled = false
    } = binding.value

    let options = {
      group,
      animation,
      store,
      handle,
      filter,
      draggable,
      ghostClass,
      chosenClass,
      dragClass,
      sort,
      disabled,
      // NOTE: 选择拖拽时调用
      onChoose(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        value && value.onChoose && value.onChoose(params, node.context)
      },
      onUnchoose(evt) {
        let params = {
          from: evt.from,
          to: evt.to,
          e: evt
        }
        value && value.onUnchoose && value.onUnchoose(params, node.context)
      },
      // NOTE: 开始时调用
      onStart(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        value && value.onStart && value.onStart(params, node.context)
      },
      // NOTE: 完成是调用
      onEnd(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          newDraggableIndex: evt.newDraggableIndex,
          oldDraggableIndex: evt.oldDraggableIndex,
          clone: evt.clone,
          pullMode: evt.pullMode,
          e: evt
        }
        if (originalData && originalData.length) {
          let temp = originalData[evt.newIndex]
          originalData[evt.newIndex] = originalData[evt.oldIndex]
          originalData[evt.oldIndex] = temp
        }
        params['originalData'] = originalData

        value && value.onEnd && value.onEnd(params, node.context)
      },
      // NOTE: 进入另外一个组里面再说
      onAdd(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          newDraggableIndex: evt.newDraggableIndex,
          oldDraggableIndex: evt.oldDraggableIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }

        if (originalData && originalData.length) {
          let temp = originalData[evt.newDraggableIndex]
          originalData[evt.newDraggableIndex] = originalData[evt.oldDraggableIndex]
          originalData[evt.oldDraggableIndex] = temp
        }
        params['originalData'] = originalData
        value && value.onAdd && value.onAdd(params, node.context)
      },
      // NOTE: 排序过后调用
      onUpdate(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        params['originalData'] = originalData
        value && value.onUpdate && value.onUpdate(params, node.context)
      },
      // NOTE: Called by any change to the list (add / update / remove)
      onSort(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        params['originalData'] = originalData
        value && value.onSort && value.onSort(params, node.context)
      },
      // NOTE: 从当前组中移出时调用
      onRemove(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          newDraggableIndex: evt.newDraggableIndex,
          oldDraggableIndex: evt.oldDraggableIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        if (originalData && originalData.length) {
          originalData.splice(evt.oldDraggableIndex, 1)
        }
        params['originalData'] = originalData
        value && value.onRemove && value.onRemove(params, node.context)
      },
      // NOTE: 过滤调用
      onFilter (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        params['originalData'] = originalData
        value && value.onRemove && value.onRemove(params, node.context)
      },
      // NOTE: 移动时调用
      onMove(evt, dragEvent) {
        let params = {
          from: evt.from,
          to: evt.to,
          dragged: evt.dragged,
          related: evt.related,
          dragEvent: dragEvent,
          e: evt
        }
        value && value.onMove && value.onMove(params, node.context)
      },
      // NOTE: 创建克隆dom时调用
      onClone(evt) {
        let params = {
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        value && value.onClone && value.onClone(params, node.context)
      },
      // NOTE: 拖拽位置时调用
      onChange (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        value && value.onChange && value.onChange(params, node.context)
      }
    }

    Array.prototype.forEach.call(children, child => {
      if (child.classList.contains(filter)) {
        child.classList.remove(draggable.replace(/\./ig, ''))
      } else {
        child.classList.add(draggable.replace(/\./ig, ''))
      }
    })
    let sortInstance = new Sortable(el, options)

    binding.value.sortInstance = sortInstance
  },
  updated (el, binding, node) {
    let value = binding.value
    let originalData = value && value.originalData ? value.originalData : []

    const {
      group = '',
      animation = 250,
      store = null,
      handle = '',
      filter = '.drag__ignore',
      draggable = '.drag__item',
      ghostClass = 'drag__selected',
      chosenClass = 'drag__chosen',
      dragClass = 'drag__sortable',
      sort = true,
      disabled = false
    } = binding.value

    let options = {
      group,
      animation,
      store,
      handle,
      filter,
      draggable,
      ghostClass,
      chosenClass,
      dragClass,
      sort,
      disabled,
      // NOTE: 选择拖拽时调用
      onChoose(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        value && value.onChoose && value.onChoose(params, node.context)
      },
      onUnchoose(evt) {
        let params = {
          from: evt.from,
          to: evt.to,
          e: evt
        }
        value && value.onUnchoose && value.onUnchoose(params, node.context)
      },
      // NOTE: 开始时调用
      onStart(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        value && value.onStart && value.onStart(params, node.context)
      },
      // NOTE: 完成是调用
      onEnd(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          newDraggableIndex: evt.newDraggableIndex,
          oldDraggableIndex: evt.oldDraggableIndex,
          clone: evt.clone,
          pullMode: evt.pullMode,
          e: evt
        }
        if (originalData && originalData.length) {
          let temp = originalData[evt.newIndex]
          originalData[evt.newIndex] = originalData[evt.oldIndex]
          originalData[evt.oldIndex] = temp
        }
        params['originalData'] = originalData

        value && value.onEnd && value.onEnd(params, node.context)
      },
      // NOTE: 进入另外一个组里面再说
      onAdd(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          newDraggableIndex: evt.newDraggableIndex,
          oldDraggableIndex: evt.oldDraggableIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }

        if (originalData && originalData.length) {
          let temp = originalData[evt.newDraggableIndex]
          originalData[evt.newDraggableIndex] = originalData[evt.oldDraggableIndex]
          originalData[evt.oldDraggableIndex] = temp
        }
        params['originalData'] = originalData
        value && value.onAdd && value.onAdd(params, node.context)
      },
      // NOTE: 排序过后调用
      onUpdate(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        params['originalData'] = originalData
        value && value.onUpdate && value.onUpdate(params, node.context)
      },
      // NOTE: Called by any change to the list (add / update / remove)
      onSort(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        params['originalData'] = originalData
        value && value.onSort && value.onSort(params, node.context)
      },
      // NOTE: 从当前组中移出时调用
      onRemove(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          newDraggableIndex: evt.newDraggableIndex,
          oldDraggableIndex: evt.oldDraggableIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        if (originalData && originalData.length) {
          originalData.splice(evt.oldDraggableIndex, 1)
        }
        params['originalData'] = originalData
        value && value.onRemove && value.onRemove(params, node.context)
      },
      // NOTE: 过滤调用
      onFilter(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        params['originalData'] = originalData
        value && value.onRemove && value.onRemove(params, node.context)
      },
      // NOTE: 移动时调用
      onMove(evt, dragEvent) {
        let params = {
          from: evt.from,
          to: evt.to,
          dragged: evt.dragged,
          related: evt.related,
          dragEvent: dragEvent,
          e: evt
        }
        value && value.onMove && value.onMove(params, node.context)
      },
      // NOTE: 创建克隆dom时调用
      onClone(evt) {
        let params = {
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        value && value.onClone && value.onClone(params, node.context)
      },
      // NOTE: 拖拽位置时调用
      onChange(evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item,
          e: evt
        }
        value && value.onChange && value.onChange(params, node.context)
      }
    }

    let sortInstance = binding.value.sortInstance

    Object.keys(options).forEach(key => {
      sortInstance.option(key, options[key])
    })
  },
  unbind (el, binding) {
    binding.value.sortInstance = {}
  }
}



// WEBPACK FOOTER //
// ./src/module/drag/sortable.js